//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div
    class="go_btn"
    :style="{ background: store.state.Style.themeColor }"
    @click="click"
  >
    <slot />
  </div>
</template>

<script setup>
import AnalyticsEvent from "@/../../../common/models/AnalyticsEvent.js";
import { defineProps, inject } from "vue";
import { useStore } from "vuex";

const props = defineProps(["actions", "event"]);
const api = inject("api");
const actionsManager = inject("actionsManager");
const store = useStore();

function click() {
  if (props.actions) {
    actionsManager.addActions(props.actions);
  }
  if (props.event) {
    api.analytics.log(
      new AnalyticsEvent(
        props.event.title,
        props.event.eventType,
        props.event.category
      )
    );
  }
}
</script>

<style lang="scss" scoped>
.go_btn {
  color: #fff;
  font-weight: bold;
  border-radius: 15px;
  padding: 10px 20px;
  margin: 0 auto;
  cursor: pointer;
}
</style>
